/* eslint-disable eqeqeq */
/* eslint-disable max-len */

export const csvEscape = (inputString) => {
  // replace all double-quotes with two double-quotes when double-quoting a value
  // see the spec for csv
  const input =
    (inputString == null)
      ? ''
      : ((typeof inputString != 'string')
        ? ((inputString.toString) ? inputString.toString() : `${inputString}`)
        : inputString);
  return `"${input.replace(/"/g, '""')}"`;
};

/**
 * object format is as follows:
 * - `inputObject` has a string array called `cols` and an object array called `rows`
 * - `cols` defines the column headers
 * - each `rows` object has an object array `vals` and optional object array `rows`
 * - each `vals` object has a number `c` and a string `v`
 * - `c` is the column number and `v` is the value for that column
 * - `vals` has length no greater than `cols.length`
 * - if the strings in `vals` repeat, `rows` is defined recursively in order to only specify the values that change
 */
export const objectToCSV = (inputObject) => {
  try {
    let csvString = `${inputObject.cols.map(csvEscape).join()}\n`; // join() adds the commas
    const outputRow = new Array(inputObject.cols.length);
    outputRow.fill(',');
    const rowsToProcess = [];
    for (let i = inputObject.rows.length - 1; i >= 0; --i) {
      // iterate backward to maintain order when popped
      // TODO: check that this is faster than a single `push(...(rows.reverse()))`
      rowsToProcess.push(inputObject.rows[i]);
    }
    while (rowsToProcess.length > 0) {
      const row = rowsToProcess.pop(); // LIFO for depth first traversal
      row.vals.forEach((val) => {
        outputRow[val.c] = csvEscape(val.v);
      });
      if (row.rows != undefined && row.rows.length) {
        for (let j = row.rows.length - 1; j >= 0; --j) {
          // iterate backward to maintain order when popped
          // TODO: check that this is faster than a single `push(...(rows.reverse()))`
          rowsToProcess.push(row.rows[j]);
        }
      } else {
        csvString += `${outputRow.join()}\n`; // join() adds the commas
      }
    }
    return csvString;
  } catch (err) {
    console.error(err);
    return '';
  }
};

/**
 * Expects dataArray to be an array of objects (corresponding to table rows)
 * with numerically keyed values, the number being the column number.
 */
export const arrayToCSV = (dataArray, headers) => {
  try {
    let csvString = `${headers.map(csvEscape).join()}\n`; // join() adds the commas
    const outputRow = new Array(headers.length);
    outputRow.fill(',');
    for (let i = 0; i < dataArray.length; ++i) {
      const row = dataArray[i];
      for (let j = 0; j < headers.length; ++j) {
        outputRow[j] = csvEscape(row[j]);
      }
      csvString += `${outputRow.join()}\n`; // join() adds the commas
    }
    return csvString;
  } catch (err) {
    return '';
  }
};



// WEBPACK FOOTER //
// ./src/utils/csv-util.js